import i18next from 'i18next';
import { _URL_FORM, abrirFormCadastro, btnAcoesItensCurriculo, fecharFormCadastro } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

export const experiencias = function (semExperiencia) {
    "use strict";
    var _excluir = function (id) {
        swal({
            title: i18next.t('experienciaRemoverTitulo'),
            html: i18next.t('experienciaRemoverDescricao'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show('#panel-experiencia');
            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteExperiencia?id=' + id, cache: false,
                success: function (data) {
                    if (data.success == 1) {
                        body.find('#experiencia-item-' + id).remove();
                        toastr.success(i18next.t('experienciaRemoverSucesso'), '', { "closeButton": true });
                        progressoCurriculo();
                        _listar(false);
                    } else {
                        swal("", data.error, "error");
                    }
                    window.global.loaderPanel.hide('#panel-experiencia');
                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-experiencia');
                    swal(i18next.t('erroServidor'), '', "error");
                }
            });
        });

    };
    var _configurarModoPausa = function (formulario, isPausa) {
        if (isPausa) {
            formulario.find('.campos-experiencia').addClass('hide');
            formulario.find('.campos-pausa').removeClass('hide');
            formulario.find('#experiencia-pausa-carreira').val('true');
            formulario.find('#title-box').html('<i class="fa fa-pause mr5"></i>' + i18next.t('pausaCarreiraTitulo'));
            // Remover validação required dos campos de experiência ocultos
            formulario.find('.campos-experiencia').find('[data-validation="required"]').attr('data-validation-optional', 'true');
            // Adicionar validação ao tipo de pausa
            formulario.find('#experiencia-tipo-pausa').attr('data-validation', 'required');
            // Data de saída não obrigatória para pausa
            formulario.find('#experiencia-mes-saida').attr('data-validation-optional', 'true');
            formulario.find('#experiencia-ano-saida').attr('data-validation-optional', 'true');
            // Configurar contador de caracteres da descrição de pausa
            formulario.find('#experiencia-descricao-pausa').restrictLength($('#maxlengthDescricaoPausa'));
        } else {
            formulario.find('.campos-experiencia').removeClass('hide');
            formulario.find('.campos-pausa').addClass('hide');
            formulario.find('#experiencia-pausa-carreira').val('false');
        }
    };
    var _listar = function (semExperiencia) {
        var panel = body.find('#panel-experiencia');
        window.global.loaderPanel.show('#panel-experiencia');

        if (semExperiencia) {
            panel.find('.panel-body').addClass('hide');
            panel.find('.btn-add').removeClass('hide');
            panel.find('.label-nao-possui').removeClass('hide');
            panel.find('.panel-footer').addClass('hide');
            window.global.loaderPanel.hide('#panel-experiencia');

        } else {

            $.ajax({
                type: "GET",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetExperiencias', cache: false,
                success: function (dados) {
                    var dadosLength = dados.experiencias.length, html = [], item = '', voluntario = '';
                    var elementNull = document.getElementById("experiencia-null");

                    if (dadosLength > 0) {
                        elementNull.className = 'hide';
                        for (var i = 0; i < dadosLength; i++) {
                            var exp = dados.experiencias[i];
                            item = '<li class="list-group-item" id="experiencia-item-' + exp.id + '" data-cargo="' + exp.cargo + '" data-cidade="' + exp.cidade + '" data-voluntario="' + exp.voluntario + '" data-empresa="' + exp.empresa + '" data-porte="' + exp.porteID + '" data-mes-entrada="' + exp.mesInicio + '" data-ano-entrada="' + exp.anoInicio + '" data-mes-saida="' + exp.mesFim + '" data-ano-saida="' + exp.anoFim + '" data-atual="' + exp.atual + '" data-pausa-carreira="' + exp.pausaCarreira + '" data-tipo-pausa-carreira="' + exp.tipoPausaCarreira + '">' + btnAcoesItensCurriculo(exp.id);

                            if (exp.pausaCarreira) {
                                // Renderização para pausa na carreira - estilo destacado
                                item = '<li class="list-group-item" id="experiencia-item-' + exp.id + '" data-cargo="' + exp.cargo + '" data-cidade="' + exp.cidade + '" data-voluntario="' + exp.voluntario + '" data-empresa="' + exp.empresa + '" data-porte="' + exp.porteID + '" data-mes-entrada="' + exp.mesInicio + '" data-ano-entrada="' + exp.anoInicio + '" data-mes-saida="' + exp.mesFim + '" data-ano-saida="' + exp.anoFim + '" data-atual="' + exp.atual + '" data-pausa-carreira="' + exp.pausaCarreira + '" data-tipo-pausa-carreira="' + exp.tipoPausaCarreira + '" style="background-color: #FFFDF8; border-left: 4px solid #E2E8F0; border-radius: 0;">' + btnAcoesItensCurriculo(exp.id);
                                item += '<p style="margin-bottom: 5px;"><span style="background-color: #FFF2CC; color: #856404; padding: 4px 10px; border-radius: 20px; font-weight: bold; padding: 5px 10px; font-size: 12px;"><i class="fa fa-pause mr5"></i>' + i18next.t('pausaCarreiraTitulo') + '</span></p>';
                                item += '<h4><b>' + exp.tipoPausaCarreiraDescricao + '</b></h4>';
                                if (String(exp.anoInicio) !== '9999') {
                                    item += '<p><span class="text-muted">' + exp.periodoPorExtenso + '</span></p>';
                                } else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaDataNull') + '</span></p>';
                                }
                                if (!isNullOrEmpty(exp.descricao)) {
                                    item += '<p>' + exp.descricao.replace(/(\r\n|\n|\r)/gm, "<br>") + '</p>';
                                    item += '<p class="experiencia-atividades hide">' + exp.descricao + '</p>';
                                }
                            } else {
                                // Renderização para experiência normal
                                voluntario = exp.voluntario ? i18next.t('experienciaVoluntario') : '';

                                if (!isNullOrEmpty(exp.cargo)) {
                                    item += '<h4 class="nomargin"><b>' + exp.cargo + '</b> ' + voluntario + '</h4>';
                                } else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaInformeCargo') + '</span></p>';
                                }

                                if (!isNullOrEmpty(exp.empresa)) {
                                    item += `<p><b>${exp.empresa}</b> ${(!isNullOrEmpty(exp.porte) ? `(${exp.porte})` : ``)}</p>`;
                                } else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaEmpresaNull') + '</span></p>';
                                }

                                if (!isNullOrEmpty(exp.cidade)) {
                                    item += '<p><i class="fa fa-map-marker"></i> ' + exp.cidade + '</p>';
                                } else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaCidadeNull') + '</span></p>';
                                }

                                if (String(exp.anoInicio) !== '9999') {
                                    item += '<p><span class="text-muted">' + exp.periodoPorExtenso + '</span></p>';
                                } else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaDataNull') + '</span></p>';
                                }
                                if (!isNullOrEmpty(exp.descricao)) {
                                    item += '<p>' + exp.descricao.replace(/(\r\n|\n|\r)/gm, "<br>") + '</p>';
                                    item += '<p class="experiencia-atividades hide">' + exp.descricao + '</p>';
                                }
                                else {
                                    item += '<p><span class="alert alert-sm alert-warning cursor-pointer btn-editar" data-id="' + exp.id + '"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('experienciaAtividadeNull') + ' </span></p>';
                                }
                                if (!isNullOrEmpty(exp.resultado)) {
                                    item += '<p><b>' + i18next.t('experienciaResultado') + ' </b><span>' + exp.resultado.replace(/(\r\n|\n|\r)/gm, "<br>") + '</span></p>';
                                    item += '<span class="experiencia-resultados hide">' + exp.resultado + '</span>';
                                }
                            }
                            item += '</li>';
                            html.push(item);
                        }
                        document.getElementById('experiencia-lista').innerHTML = html.join('');
                        panel.find('.btn-excluir').on('click', function () {
                            var id = $(this).attr('data-id');
                            _excluir(id);
                        });
                        panel.find('.btn-editar').on('click', function () {
                            var id = $(this).attr('data-id');
                            _abrir(id);
                        });
                        panel.find('.label-nao-possui').addClass('hide');
                        panel.find('.btn-add').removeClass('hide');

                    } else {
                        elementNull.className = '';
                    }

                    window.global.loaderPanel.hide('#panel-experiencia');

                },
                error: function () {
                    window.global.loaderPanel.hide('#panel-experiencia');
                }
            });
        }
    };
    var limparHTML = function (str) {
        var div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
    };
    var _salvar = function () {
        var content = body.find('#form-experiencia');

        var id = content.find('#experiencia-id').val();
        var pausaCarreira = content.find('#experiencia-pausa-carreira').val() === 'true';

        var mesInicio = content.find('#experiencia-mes-entrada').val();
        var anoInicio = content.find('#experiencia-ano-entrada').val();
        var mesFim = content.find('#experiencia-mes-saida').val();
        var anoFim = content.find('#experiencia-ano-saida').val();
        var atual = pausaCarreira
            ? content.find('#pausa-em-andamento').is(':checked')
            : content.find('#experiencia-atual').is(':checked');

        var postData = {
            ID: id,
            mesInicio: mesInicio,
            anoInicio: anoInicio,
            mesFim: mesFim,
            anoFim: anoFim,
            Atual: atual,
            PausaCarreira: pausaCarreira
        };

        if (pausaCarreira) {
            postData.TipoPausaCarreira = content.find('#experiencia-tipo-pausa').val();
            postData.Descricao = limparHTML(content.find('#experiencia-descricao-pausa').val());
            postData.Cargo = '';
            postData.Empresa = '';
            postData.Voluntario = false;
            postData.Porte = 0;
            postData.Cidade = '';
            postData.Resultado = '';
        } else {
            postData.Cargo = limparHTML(content.find('#experiencia-cargo').val());
            postData.Empresa = limparHTML(content.find('#experiencia-empresa').val());
            postData.Descricao = limparHTML(content.find('#experiencia-atividades').val());
            postData.Resultado = limparHTML(content.find('#experiencia-resultados').val());
            postData.Voluntario = content.find('#experiencia-voluntario').is(':checked');
            postData.Porte = content.find('#experiencia-porte').val();
            postData.Cidade = limparHTML(content.find('#experiencia-cidade').val());
        }

        window.global.loaderButton.show(content.find('button[type=submit]'));

        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveExperiencia', cache: false,
            data: postData,
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('experienciaSalva'), '', { "closeButton": true });
                    if (id == 0 && !pausaCarreira) {
                        swal({
                            title: i18next.t('experienciaSalvaOutra'),
                            html: i18next.t('experienciaSalvaOutraDesc'),
                            type: "info",
                            showCancelButton: true,
                            confirmButtonColor: "#40afdf",
                            confirmButtonText: i18next.t('experienciaSalvaOutraBtn'),
                            cancelButtonText: i18next.t('btnNaoPossuo'),
                            closeOnConfirm: true
                        }, function (isConfirm) {
                            if (isConfirm) {
                                _abrir(0);
                            }
                        });
                    }

                    _listar(false);
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    swal("", data.error, "error");
                    window.global.loaderButton.hide(content.find('button[type=submit]'));
                }

            },
            error: function () {
                window.global.loaderButton.hide(content.find('button[type=submit]'));
                swal('', i18next.t('erroServidor'), "error");
            }
        });
    };
    var _fechar = function () {
        document.getElementById('experiencia-contentform').innerHTML = '';
        goToByScroll('#panel-experiencia');
        fecharFormCadastro();
    };
    var _setEmpregoAtual = function () {

        if (body.find('#experiencia-atual').is(':checked') || body.find('#pausa-em-andamento').is(':checked')) {
            var elementValid = body.find('#experiencia-data-saida');
            elementValid.find('div').removeClass('has-error');
            elementValid.find('div').removeClass('has-success');
            elementValid.find('.form-error').remove();
            elementValid.find('select').removeAttr('style');

            body.find('#experiencia-mes-saida').val('').attr('disabled', 'disabled');
            body.find('#experiencia-ano-saida').val('').attr('disabled', 'disabled');
        }
        else {
            body.find('#experiencia-mes-saida').val('').removeAttr('disabled');
            body.find('#experiencia-ano-saida').val('').removeAttr('disabled');
        }
    };
    var _naoPossui = function () {
        var btn = body.find('#panel-experiencia').find('.btn-nao-possui');
        window.global.loaderButton.show(btn);
        $.ajax({
            type: "POST",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/SaveExperiencia', cache: false,
            data: {
                remover: 1
            },
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('experienciaSalva'), '', { "closeButton": true });
                    _listar(true);
                    progressoCurriculo();
                }
                else {
                    swal("", data.error, "error");
                }
                window.global.loaderButton.hide(btn);
            },
            error: function () {
                window.global.loaderButton.hide(btn);
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    var _abrir = function (id, isPausa) {
        goToByScroll('#panel-experiencia');
        body.find('#panel-experiencia').find('.panel-body').removeClass('hide');

        window.global.loaderFull.show();
        var formulario = body.find('#experiencia-contentform');
        var dataCargo = {};
        var decodeHTML = function (str) {
            var txt = document.createElement("textarea");
            txt.innerHTML = str;
            return txt.value;
        };

        abrirFormCadastro();
        formulario.load(_URL_FORM + "Experiencia?v=3", function () {
            $.validate({
                form: '#form-experiencia'
            });
            formulario.find('#experiencia-atividades').restrictLength($('#maxlengthAtividades'));
            formulario.find('#experiencia-resultados').restrictLength($('#maxlengthResultados'));

            formulario.find('.close-panel').on('click', function (e) {
                _fechar();

                const panelExperiencia = document.querySelector('#panel-experiencia');
                if (!panelExperiencia.querySelector('.label-nao-possui').classList.contains('hide'))
                    panelExperiencia.querySelector('.panel-body').classList.add('hide');

                e.preventDefault();
            });
            formulario.find('#experiencia-atual').on('click', function () {
                _setEmpregoAtual();
            });
            formulario.find('#pausa-em-andamento').on('click', function () {
                _setEmpregoAtual();
            });
            formulario.find('#form-experiencia').on('submit', function (e) {
                if ($(this).isValid()) {
                    _salvar();
                }
                e.preventDefault();
            });

            tooltipPorteEmpresa();

            if (id > 0) {
                var item = body.find('#experiencia-item-' + id);
                var itemIsPausa = item.attr('data-pausa-carreira') === 'true';

                if (itemIsPausa) {
                    _configurarModoPausa(formulario, true);
                    formulario.find('#title-box').html('<i class="fa fa-edit mr5"></i> ' + i18next.t('experienciaEditarPausa'));
                    formulario.find('#experiencia-tipo-pausa').val(item.attr('data-tipo-pausa-carreira'));
                    formulario.find('#experiencia-descricao-pausa').val(decodeHTML(item.find('.experiencia-atividades').html() || ""));
                } else {
                    _configurarModoPausa(formulario, false);
                    formulario.find('#title-box').html('<i class=\"fa fa-edit mr5\"></i> ' + i18next.t('experienciaEditarTitle'));
                    if (item.attr('data-voluntario') == 'true') {
                        formulario.find('#experiencia-voluntario').prop('checked', true);
                    } else {
                        formulario.find('#experiencia-voluntario').prop('checked', false);
                    }
                    formulario.find('#experiencia-empresa').val(item.attr('data-empresa'));
                    formulario.find('#experiencia-cargo').val(item.attr('data-cargo'));
                    formulario.find('#experiencia-porte').val(item.attr('data-porte'));

                    var cidade = item.attr('data-cidade');
                    formulario.find('#experiencia-cidade').val((!cidade || cidade === "null" || cidade === "undefined") ? "" : cidade);

                    formulario.find('#experiencia-atividades').val(decodeHTML(item.find('.experiencia-atividades').html()));
                    formulario.find('#experiencia-resultados').val(decodeHTML(item.find('.experiencia-resultados').html() || ""));
                }

                var expEntradaAberta = item.attr('data-ano-entrada') === '9999';
                formulario.find('#experiencia-mes-entrada').val(expEntradaAberta ? '' : item.attr('data-mes-entrada'));
                formulario.find('#experiencia-ano-entrada').val(expEntradaAberta ? '' : item.attr('data-ano-entrada'));

                if (item.attr('data-atual') == 'true') {
                    if (itemIsPausa) {
                        body.find('#pausa-em-andamento').prop('checked', true);
                    } else {
                        body.find('#experiencia-atual').prop('checked', true);
                    }
                    _setEmpregoAtual();
                } else {
                    body.find('#experiencia-atual').prop('checked', false);
                    body.find('#pausa-em-andamento').prop('checked', false);
                    var expSaidaAberta = item.attr('data-ano-saida') === '9999';
                    formulario.find('#experiencia-mes-saida').val(expSaidaAberta ? '' : item.attr('data-mes-saida'));
                    formulario.find('#experiencia-ano-saida').val(expSaidaAberta ? '' : item.attr('data-ano-saida'));
                }

                formulario.find('#experiencia-id').val(id);

            } else if (isPausa) {
                _configurarModoPausa(formulario, true);
            }

            function OnInput() {
                this.style.height = 0;
                this.style.height = (this.scrollHeight + 50) + "px";
            }

            const tx = document.getElementsByTagName("textarea");
            for (let i = 0; i < tx.length; i++) {
                tx[i].setAttribute("style", "height:" + (tx[i].scrollHeight + 50) + "px;overflow-y:hidden;");
                tx[i].addEventListener("input", OnInput, false);
            }

            janelaAjuda(formulario);
            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
        });


    };

    var init = function () {
        _listar(semExperiencia);

        body.find('#panel-experiencia').find('.btn-add-experiencia').on('click', function (e) {
            _abrir(0, false);
            e.preventDefault();
        });

        body.find('#panel-experiencia').find('.btn-add-pausa').on('click', function (e) {
            _abrir(0, true);
            e.preventDefault();
        });

        body.find('#panel-experiencia').find('.btn-nao-possui').on('click', function (e) {
            _naoPossui();
            e.preventDefault();
        });
    }

    return init();
};

